module.exports = __webpack_public_path__ + "static/media/change.c0870466.svg";